var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionConfig,
          "left-side-class": "col-xl-6 pb-2",
          page: _vm.headerConfig,
          "right-side-class":
            "col-xl-6 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _vm.addingAddendum
        ? _c("add-addendum", {
            on: {
              "on-cancel": () => (this.addingAddendum = false),
              "on-continue": function($event) {
                return _vm.onContinueAddAddendumHandler($event)
              }
            }
          })
        : _vm._e(),
      _vm.inEditMode
        ? _c("board", {
            staticClass: "mb-4",
            attrs: { details: _vm.board },
            scopedSlots: _vm._u(
              [
                {
                  key: "data-item",
                  fn: function({ item }) {
                    return [
                      item.statusName
                        ? _c(
                            "div",
                            [
                              _c("balloon", {
                                attrs: {
                                  bg: `border-none text-center bg-${_vm.getStatusColor(
                                    item.statusId
                                  )}`,
                                  dot: "",
                                  text: item.statusName
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }
                }
              ],
              null,
              false,
              2039304081
            )
          })
        : _vm._e(),
      _c(
        "validation-observer",
        { ref: "formValidator" },
        [
          _c(
            "b-tabs",
            {
              attrs: {
                "nav-class": "custom-nav-container",
                "no-nav-style": true
              },
              model: {
                value: _vm.tabModel,
                callback: function($$v) {
                  _vm.tabModel = $$v
                },
                expression: "tabModel"
              }
            },
            [
              _c(
                "b-tab",
                {
                  staticClass: "bid-tabs",
                  attrs: {
                    id: "information",
                    "content-class": "mt-3 pb-3",
                    lazy: false
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function() {
                        return [
                          _c(
                            "span",
                            {
                              class: {
                                "tab-title-error":
                                  _vm.tabErrorKey === "information"
                              }
                            },
                            [
                              _vm._v(" Información del Pliego "),
                              _vm.tabErrorKey === "information"
                                ? _c("i", {
                                    staticClass:
                                      "fas fa-exclamation-triangle text-danger ml-1"
                                  })
                                : _vm._e()
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm.model.purchaseService
                    ? [
                        _c("section-title", {
                          staticClass: "mt-4",
                          attrs: {
                            content: "Información de Compra de Servicio",
                            icon: "fas fa-info",
                            reverse: ""
                          }
                        }),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 col-lg-3 mb-3" },
                            [
                              _c("label", { staticClass: "data-label" }, [
                                _vm._v(" Fecha de Solicitud: ")
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("date")(
                                        _vm.model.purchaseService.date
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 col-lg-3 mb-3" },
                            [
                              _c("label", { staticClass: "data-label" }, [
                                _vm._v(" Número de Solicitud: ")
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm.model.purchaseService.number
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 col-lg-3 mb-3" },
                            [
                              _c("label", { staticClass: "data-label" }, [
                                _vm._v(" Tipo de Contratación: ")
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm.model.purchaseService.contractType
                                          ?.name
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 col-lg-3 mb-3" },
                            [
                              _c("label", { staticClass: "data-label" }, [
                                _vm._v(" Nombre del Solicitante: ")
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm.model.purchaseService.contactName
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 col-lg-3 mb-3" },
                            [
                              _c("label", { staticClass: "data-label" }, [
                                _vm._v(" Oficina: ")
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm.model.purchaseService.contactOffice
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 col-lg-3 mb-3" },
                            [
                              _c("label", { staticClass: "data-label" }, [
                                _vm._v(" Teléfono: ")
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm.model.purchaseService
                                          .contactPhoneNumber
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 col-lg-3 mb-3" },
                            [
                              _c("label", { staticClass: "data-label" }, [
                                _vm._v(" Correo Electrónico: ")
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm.model.purchaseService.contactEmail
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    : _vm._e(),
                  _c("section-title", {
                    staticClass: "mt-4",
                    attrs: {
                      content: "Información del Pliego",
                      icon: "fas fa-info",
                      reverse: ""
                    }
                  }),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Favor completar título.",
                                      disabled: _vm.titleDisabled,
                                      error: errors[0],
                                      label: "Título:"
                                    },
                                    model: {
                                      value: _vm.model.title,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "title", $$v)
                                      },
                                      expression: "model.title"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-4 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      clearable: !_vm.isAreaDisabled,
                                      "custom-error-msg":
                                        "Favor seleccionar área.",
                                      disabled: _vm.isAreaDisabled,
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Área:",
                                      options: _vm.areas,
                                      placeholder: "Seleccione"
                                    },
                                    on: { input: _vm.onChangeArea },
                                    model: {
                                      value: _vm.model.area,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "area", $$v)
                                      },
                                      expression: "model.area"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    !_vm.isInfraBid
                      ? _c(
                          "div",
                          { staticClass: "col-12 col-md-4 mb-3" },
                          [
                            _c("validation-provider", {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            clearable: !_vm.isServiceDisabled,
                                            "custom-error-msg":
                                              "Favor seleccionar un servicio a ofrecer.",
                                            disabled: _vm.isServiceDisabled,
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            label: "Servicio a Ofrecer:",
                                            options: _vm.services,
                                            placeholder: "Seleccione"
                                          },
                                          model: {
                                            value: _vm.model.service,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "service",
                                                $$v
                                              )
                                            },
                                            expression: "model.service"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3284232963
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "row" }, [
                    !_vm.isReadonly
                      ? _c("div", { staticClass: "col-md-4 mb-3" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("custom-drop-down", {
                                attrs: {
                                  clearable: false,
                                  fieldkey: "id",
                                  fieldname: "name",
                                  label: "Tipo de Proveedor:",
                                  options: _vm.providerTypes,
                                  placeholder: "Seleccione"
                                },
                                model: {
                                  value: _vm.providerTypeSelected,
                                  callback: function($$v) {
                                    _vm.providerTypeSelected = $$v
                                  },
                                  expression: "providerTypeSelected"
                                }
                              }),
                              _c(
                                "action-button",
                                {
                                  staticClass: "mt-3 align-end",
                                  attrs: {
                                    i: "fas fa-file-plus",
                                    variant: "success"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addProviderType()
                                    }
                                  }
                                },
                                [_vm._v(" Añadir ")]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col-md-8 mb-3 border-left" },
                      [
                        _c("custom-chips-group", {
                          staticClass: "mt-n3 chips-group-providers",
                          attrs: {
                            disabled: _vm.isReadonly,
                            "no-background": "",
                            "no-wrap": "",
                            "object-text": "name",
                            "on-item-deleted": _vm.onDeleteProviderTypeHandler,
                            "selected-items": _vm.providerTypesAdded,
                            title: "Tipo(s) de Proveedor(es) Seleccionado(s):"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Favor seleccionar tipo de servicio.",
                                      disabled: _vm.isReadonly,
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Tipo de Servicio:",
                                      options: _vm.serviceTypes,
                                      placeholder: "Seleccione"
                                    },
                                    model: {
                                      value: _vm.model.serviceType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "serviceType", $$v)
                                      },
                                      expression: "model.serviceType"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-6 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Favor seleccionar región.",
                                      disabled: _vm.regionDisabled,
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Región:",
                                      options: _vm.regions,
                                      placeholder: "Seleccione"
                                    },
                                    model: {
                                      value: _vm.model.region,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "region", $$v)
                                      },
                                      expression: "model.region"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-date-picker", {
                                    staticClass: "custom-date-picker__extended",
                                    attrs: {
                                      "custom-error-msg":
                                        "Favor seleccionar fecha de publicación.",
                                      disabled: _vm.isReadonly,
                                      error: errors[0],
                                      label: "Fecha de Publicación:",
                                      "min-date": _vm.minPublishDate,
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.model.startDate = null
                                      }
                                    },
                                    model: {
                                      value: _vm.model.publishDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "publishDate", $$v)
                                      },
                                      expression: "model.publishDate"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-date-picker", {
                                    staticClass: "custom-date-picker__extended",
                                    attrs: {
                                      "custom-error-msg":
                                        "Favor seleccionar fecha de comienzo.",
                                      disabled: _vm.dateDisabled,
                                      error: errors[0],
                                      label: "Fecha de Comienzo:",
                                      "min-date": _vm.minStartDate,
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    on: { input: _vm.resetDates },
                                    model: {
                                      value: _vm.model.startDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "startDate", $$v)
                                      },
                                      expression: "model.startDate"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4 mb-3" },
                      [
                        _vm.isReadonly &&
                        !_vm.model.preAuctionDate &&
                        _vm.dateDisabled
                          ? _c("div", [
                              _c("label", { staticClass: "data-label" }, [
                                _vm._v("Fecha de Presubasta:")
                              ]),
                              _c("div", [_vm._v("-")])
                            ])
                          : _c("custom-date-picker", {
                              staticClass: "custom-date-picker__extended",
                              attrs: {
                                disabled: _vm.dateDisabled,
                                label: "Fecha de Presubasta:",
                                "max-date": _vm.model.endDate,
                                "min-date": _vm.minPreAuctionDate,
                                placeholder: "DD/MM/YYYY"
                              },
                              model: {
                                value: _vm.model.preAuctionDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "preAuctionDate", $$v)
                                },
                                expression: "model.preAuctionDate"
                              }
                            })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-date-picker", {
                                    staticClass: "custom-date-picker__extended",
                                    attrs: {
                                      "custom-error-msg":
                                        "Favor seleccionar fecha de finalización.",
                                      disabled: _vm.dateDisabled,
                                      error: errors[0],
                                      label: "Fecha de Finalización:",
                                      "min-date": _vm.minEndDate,
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    on: { input: _vm.resetDates },
                                    model: {
                                      value: _vm.model.endDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "endDate", $$v)
                                      },
                                      expression: "model.endDate"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _c("label", { staticClass: "data-label" }, [
                        _vm._v("Descripción del Anuncio:")
                      ]),
                      _vm.descriptionDisabled
                        ? _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.model.description)
                            }
                          })
                        : _c("validation-provider", {
                            attrs: {
                              "custom-messages": {
                                required:
                                  "Favor completar descripción del anuncio"
                              },
                              name: "descriptionditor",
                              rules: "required"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function({ errors, classes }) {
                                  return [
                                    _c("custom-editor", {
                                      class: {
                                        "was-Invalidated": classes.invalid
                                      },
                                      attrs: {
                                        placeholder: "Redacte una descripción"
                                      },
                                      model: {
                                        value: _vm.model.description,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression: "model.description"
                                      }
                                    }),
                                    errors[0] && errors[0].length > 0
                                      ? _c("Error", {
                                          attrs: {
                                            message: errors[0],
                                            variant: "no-border"
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                    ],
                    1
                  ),
                  _c("section-title", {
                    staticClass: "section-title__extended mt-4",
                    attrs: {
                      content: "Configuración de Pliego",
                      icon: "fas fa-folder-open text-orange",
                      reverse: ""
                    }
                  }),
                  _c("configuration", {
                    attrs: {
                      "is-read-only": _vm.isReadonly,
                      "is-submitting": _vm.isSubmitting,
                      services: _vm.services
                    },
                    model: {
                      value: _vm.model,
                      callback: function($$v) {
                        _vm.model = $$v
                      },
                      expression: "model"
                    }
                  }),
                  _c("section-title", {
                    staticClass: "section-title__extended mt-4",
                    attrs: {
                      content:
                        "Documentos Relacionados a la Solicitud de Propuestas",
                      icon: "fas fa-cloud-upload-alt text-orange",
                      reverse: ""
                    }
                  }),
                  _c("bid-document", {
                    attrs: {
                      "adding-addendum": _vm.documentsDisabled,
                      documents: _vm.model.documents,
                      "read-only": _vm.isReadonly
                    },
                    on: {
                      "on-add-document": _vm.addDocumentHandler,
                      "on-remove-document": _vm.removeDocumentHandler
                    }
                  }),
                  _c("section-title", {
                    staticClass: "section-title__extended mt-4",
                    attrs: {
                      content: "Información de Contacto",
                      icon: "fas fa-user-circle text-orange",
                      reverse: ""
                    }
                  }),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-md-6 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            "custom-messages": {
                              required: "Favor completar teléfono de contacto.",
                              length: "El teléfono es invalido"
                            },
                            rules: "required|length:13"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      disabled: _vm.contactDisabled,
                                      error: errors[0],
                                      label: "Número de Teléfono:",
                                      "mask-type": "Phone",
                                      masked: true,
                                      placeholder: ""
                                    },
                                    model: {
                                      value: _vm.model.phone,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "phone", $$v)
                                      },
                                      expression: "model.phone"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-md-6 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            "custom-messages": {
                              required: "Favor completar correo electrónico.",
                              email: "El correo electrónico no es válido."
                            },
                            rules: "required|email"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      disabled: _vm.contactDisabled,
                                      error: errors[0],
                                      label: "Correo Electrónico:"
                                    },
                                    model: {
                                      value: _vm.model.email,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "email", $$v)
                                      },
                                      expression: "model.email"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ])
                ],
                2
              ),
              _vm.model.id
                ? _c(
                    "b-tab",
                    {
                      staticClass: "bid-tabs",
                      attrs: {
                        id: "proposalDocuments",
                        "content-class": "mt-3 pb-3",
                        lazy: false
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "tab-title-error":
                                        _vm.tabErrorKey === "proposalDocuments"
                                    }
                                  },
                                  [
                                    _vm._v(" Documentos de la Propuesta "),
                                    _vm.tabErrorKey === "proposalDocuments"
                                      ? _c("i", {
                                          staticClass:
                                            "fas fa-exclamation-triangle text-danger ml-1"
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3686511386
                      )
                    },
                    [
                      _c("document-types", {
                        attrs: {
                          "announcement-id": _vm.model.id,
                          "read-only": _vm.isReadonly
                        },
                        on: {
                          "refresh-detail": function($event) {
                            return _vm.refreshData()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.model.determinationPurchaseServiceId
                ? _c(
                    "b-tab",
                    {
                      staticClass: "bid-tabs",
                      attrs: {
                        id: "determinationDocuments",
                        "content-class": "mt-3 pb-3",
                        lazy: false
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "tab-title-error":
                                        _vm.tabErrorKey ===
                                        "determinationDocuments"
                                    }
                                  },
                                  [
                                    _vm._v(" Documentos de Solicitud "),
                                    _vm.tabErrorKey === "determinationDocuments"
                                      ? _c("i", {
                                          staticClass:
                                            "fas fa-exclamation-triangle text-danger ml-1"
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3762326154
                      )
                    },
                    [
                      _c("section-title", {
                        staticClass: "section-title__extended mt-4",
                        attrs: {
                          content:
                            "Documentos de Trabajo Relacionados con la Compra de Servicios",
                          icon: "fas fa-cloud-upload-alt text-orange",
                          reverse: ""
                        }
                      }),
                      _c("determination-purchase-service-documents", {
                        attrs: {
                          id: _vm.model.determinationPurchaseServiceId,
                          "is-read-only": _vm.isReadonly,
                          "is-submitting": _vm.isSubmitting,
                          items: _vm.model.determinationPurchaseServiceDocuments
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canSeeProponents
                ? _c(
                    "b-tab",
                    {
                      staticClass: "bid-tabs",
                      attrs: { id: "proponents", "content-class": "mt-3 pb-3" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "tab-title-error":
                                        _vm.tabErrorKey === "proponents"
                                    }
                                  },
                                  [
                                    _vm._v(" Proponentes "),
                                    _vm.tabErrorKey === "proponents"
                                      ? _c("i", {
                                          staticClass:
                                            "fas fa-exclamation-triangle text-danger ml-1"
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3189460567
                      )
                    },
                    [
                      _c("proponents", {
                        attrs: {
                          id: _vm.model.determinationPurchaseServiceId,
                          "determination-category-id":
                            _vm.model.purchaseService?.determinationCategoryId,
                          "estimated-amount":
                            _vm.model.purchaseService.estimatedAmount,
                          "is-read-only": _vm.isReadonly,
                          "is-renewal-or-amendment": _vm.isRenewalOrAmendment,
                          items: _vm.model.proponents,
                          "minimum-proponents-required":
                            _vm.minimumProponentsRequired
                        },
                        on: {
                          "update:items": function($event) {
                            return _vm.$set(_vm.model, "proponents", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isReadonly
                ? _c(
                    "b-tab",
                    {
                      staticClass: "bid-tabs",
                      attrs: {
                        id: "addendumHistory",
                        "content-class": "mt-3 pb-3",
                        lazy: false
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "tab-title-error":
                                        _vm.tabErrorKey === "addendumHistory"
                                    }
                                  },
                                  [
                                    _vm._v(" Historial de Addendums "),
                                    _vm.tabErrorKey === "addendumHistory"
                                      ? _c("i", {
                                          staticClass:
                                            "fas fa-exclamation-triangle text-danger ml-1"
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1661922105
                      )
                    },
                    [
                      _c("addendum-history", {
                        attrs: {
                          history: _vm.model.addendumHistory,
                          status: _vm.model.status
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.model.proposalQuestionnaireRequired
                ? _c(
                    "b-tab",
                    {
                      staticClass: "bid-tabs",
                      attrs: {
                        id: "proposalQuestionnaire",
                        "content-class": "mt-3 pb-3"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "tab-title-error":
                                        _vm.tabErrorKey ===
                                        "proposalQuestionnaire"
                                    }
                                  },
                                  [
                                    _vm._v(" Cuestionario de Propuesta "),
                                    _vm.tabErrorKey === "proposalQuestionnaire"
                                      ? _c("i", {
                                          staticClass:
                                            "fas fa-exclamation-triangle text-danger ml-1"
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1018465965
                      )
                    },
                    [
                      _c("proposal-questionnaire", {
                        attrs: {
                          "area-id": _vm.model.area?.id,
                          "is-read-only": _vm.isReadonly,
                          "service-id": _vm.model.service?.id
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "questionnaire-error",
                              fn: function() {
                                return [
                                  _vm.tabErrorKey === "proposalQuestionnaire"
                                    ? _c(
                                        "div",
                                        { staticClass: "mt-2" },
                                        [
                                          _c("Error", {
                                            attrs: {
                                              message:
                                                "Favor seleccionar una configuración.",
                                              variant: "no-border"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          2281562851
                        ),
                        model: {
                          value: _vm.model.questionnaireConfigId,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "questionnaireConfigId", $$v)
                          },
                          expression: "model.questionnaireConfigId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.model.evaluationCommitteeRequired
                ? _c(
                    "b-tab",
                    {
                      staticClass: "bid-tabs",
                      attrs: {
                        id: "evaluators",
                        "content-class": "mt-3 pb-3",
                        lazy: false
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "tab-title-error":
                                        _vm.tabErrorKey === "evaluators"
                                    }
                                  },
                                  [
                                    _vm._v(" Evaluadores "),
                                    _vm.tabErrorKey === "evaluators"
                                      ? _c("i", {
                                          staticClass:
                                            "fas fa-exclamation-triangle text-danger ml-1"
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1800480263
                      )
                    },
                    [
                      _c("evaluator", {
                        attrs: {
                          evaluators: _vm.evaluators,
                          "read-only": _vm.model.hasEvaluatorAssigned
                        },
                        model: {
                          value: _vm.model.assignedEvaluators,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "assignedEvaluators", $$v)
                          },
                          expression: "model.assignedEvaluators"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }